import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { API_ENDPOINT } from "src/constants/endpoints";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { restaurantSegment } from "src/utils/restaurantUrl";

export default function FinixOnboardingReturn() {
  const { storeCorrelationId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { axBe } = useAxiosInterceptor();
  const [message, setMessage] = useState("Checking payment account status...");

  useEffect(() => {
    const syncStatus = async () => {
      if (!storeCorrelationId) {
        setMessage("Missing restaurant information.");
        return;
      }
      try {
        const identityId = searchParams.get("identityId");
        const query = identityId ? `?identityId=${encodeURIComponent(identityId)}` : "";
        await axBe.post(
          `${API_ENDPOINT}finix/merchant-onboarding/return/${storeCorrelationId}${query}`
        );
        navigate(
          `/restaurants/${restaurantSegment(storeCorrelationId)}/restaurant-setting?tab=paymentAccount`,
          { replace: true }
        );
      } catch (error) {
        setMessage("Unable to update payment account status. Please return to settings and refresh.");
      }
    };
    syncStatus();
  }, [axBe, navigate, searchParams, storeCorrelationId]);

  return (
    <div className="flex h-[70vh] items-center justify-center">
      <div className="rounded-2xl border border-[#e5e7eb] bg-white px-8 py-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-[#111827]">Payment Account</h1>
        <p className="mt-2 text-sm text-[#6b7280]">{message}</p>
      </div>
    </div>
  );
}
